// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1wEZU","notes":"Notes_notes__1p1is","note":"Notes_note__3I_mG","markdown":"Notes_markdown__1X1ds"};